import unauthenticatedHttp from "@/services/unauthenticatedHttp";

export async function fetchPath(id: any) {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/paths/${id}?includeChild=true`
  );

  return data;
}
